const today = new Date();
const maxDays = 90;

export const ScheduleMessagesMinMaxDates = {
    MIN_DATE: today,
    MAX_DATE: new Date().setDate(today.getDate() + maxDays),
};
